/**
 * What to tell the user when an upload fails.
 *
 * The wording is ours on purpose. The API's own `message` is not written for this audience, and
 * an error body can come from an intermediary we do not control, so it is logged rather than
 * rendered. The upload endpoints accept images and PDFs, which is what a rejected file needs to
 * hear about.
 */
export const getUploadFailureMessage = (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
        return 'You do not have permission to upload this file.';
    }
    if (status === 503) {
        return 'Uploads are temporarily unavailable. Please try again in a few minutes.';
    }
    if (typeof status === 'number' && status >= 400 && status < 500) {
        return "That file could not be uploaded. Upload a PDF or an image and try again.";
    }
    return 'Something went wrong uploading the file. Please try again.';
};
//# sourceMappingURL=get-upload-failure-message.js.map